(() => {
  let playerMute = document.getElementById('player__mute');

  if ( playerMute ) {
    playerMute.addEventListener('click', function(ev) {
      const player = document.getElementById("player");
  
      if(this.classList.contains('--muted')) {
        player.contentWindow.postMessage(message('unMute'), '*')
        this.classList.remove('--muted')
      }else {
        player.contentWindow.postMessage(message('mute'), '*')
        this.classList.add('--muted')
      }
  
    })
  }

  const message = function(func) {
    return JSON.stringify({
      event: 'command',
      func: func,
      args: []
    });
  };
 
})();
